import React, { useState } from 'react';
import GlobalDialog from '../../components/mui/Dialogue/GlobalDialog';
import { useDispatch, useSelector } from 'react-redux';
import { Box, MenuItem, TextField } from '@mui/material';
import { CancelButton, UpdateButton } from '../../components/mui/Buttons/Buttons';
import { approveRejectTask, getApprovalTasks } from '../../redux/features/taskManagementSlice';
import useHandleApiResponse from '../../Hooks/useHandleApiResponse';
import dayjs from 'dayjs';

const ApproveTask = ({ open, setOpen, approvalId, date }) => {
  const { loading } = useSelector((state) => state.taskManagement);
  const dispatch = useDispatch();
  const handleApiResponse = useHandleApiResponse();
  const [ApproveData, setApproveData] = useState({
    status: '',
    remarks: '',
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    let tempErrors = {};

    if (!ApproveData.status) {
      tempErrors.status = 'Status is required';
    }

    if (ApproveData.status == 3 && !ApproveData.remarks.trim()) {
      tempErrors.remarks = 'Remarks is required for rejection';
    }

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!validate()) return;
    const data = {
      task_approval_status: ApproveData.status,
      task_approval_remarks: ApproveData.remarks,
      task_approval_id: approvalId,
    };
    dispatch(approveRejectTask(data)).then((res) => {
      handleApiResponse(res, {
        onSuccess: () => {
          setOpen(false);
          dispatch(getApprovalTasks(dayjs(date).format('YYYY-MM')));
        },
        onFailed: () => {
          console.log('Something went wrong');
        },
      });
    });
  };

  return (
    <GlobalDialog
      title={'Approve Task'}
      open={open}
      setOpen={setOpen}
      closeButton={true}
      fullWidth
      maxWidth={'sm'}
      content={
        <form onSubmit={handleSubmit}>
          <Box>
            <TextField
              select
              fullWidth
              required
              label="Select Status"
              value={ApproveData.status}
              onChange={(e) => setApproveData({ ...ApproveData, status: e.target.value, remarks: '' })}
              error={!!errors.status}
              helperText={errors.status}
            >
              {[
                { task_approval_status: 2, name: 'Approve' },
                { task_approval_status: 3, name: 'Reject' },
              ].map((item) => (
                <MenuItem key={item.task_approval_status} value={item.task_approval_status}>
                  {item.name}
                </MenuItem>
              ))}
            </TextField>

            <Box sx={{ mt: 2 }}>
              <TextField
                label="Remarks"
                fullWidth
                multiline
                rows={3}
                value={ApproveData.remarks}
                onChange={(e) =>
                  setApproveData({
                    ...ApproveData,
                    remarks: e.target.value,
                  })
                }
                error={!!errors.remarks}
                helperText={errors.remarks}
              />
            </Box>

            <Box
              sx={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: 1,
                mt: 2,
              }}
            >
              <CancelButton size="small" action={() => setOpen(false)}>
                Cancel
              </CancelButton>

              <UpdateButton type="submit" size="small" disabled={loading}>
                {loading ? 'Please wait...' : 'Update Status'}
              </UpdateButton>
            </Box>
          </Box>
        </form>
      }
    />
  );
};

export default ApproveTask;
